<template>
<div class="kd-preview-visitenkarte-hoch">
  <div class="kd-preview-visitenkarte-hoch__sides-wrapper">
    <div
      class="kd-preview-visitenkarte-hoch__side kd-preview-visitenkarte-hoch__side--front"
      :style="{ backgroundImage: `url(${images['front']})`}"
    ></div>
    <div
      class="kd-preview-visitenkarte-hoch__side kd-preview-visitenkarte-hoch__side--back"
      :style="{ backgroundImage: `url(${images['back']})`}"
    ></div>
  </div>
</div>  
</template>

<script>
export default {
  props: {
    images: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.kd-preview-visitenkarte-hoch {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.kd-preview-visitenkarte-hoch__side {
  width: 55mm;
  height: 85mm;
  background-color: white;
  background-size: cover;
  box-shadow: 0px 13px 31px 0px rgba(0,0,0,0.3);
}
.kd-preview-visitenkarte-hoch__sides-wrapper {
  display: flex;
  transform: scale(1.3);
}

.kd-preview-visitenkarte-hoch__side--front {
  margin-right: 30px;
}

</style>
